/** Detect Ace checks that mirrored the human answer instead of evaluating independently. */

import type { AceCheckResult } from "./types";

const LEGACY_DEFERRED_MARKERS = [
  "agreed with reviewer",
  "could not complete this check independently",
  "could not complete this check —",
];

export function aceCheckDeferredToHuman(check: Pick<AceCheckResult, "deferred_to_human" | "reason"> | null | undefined): boolean {
  if (!check) return false;
  if (check.deferred_to_human === true) return true;
  const reason = (check.reason ?? "").toLowerCase();
  return LEGACY_DEFERRED_MARKERS.some((marker) => reason.includes(marker));
}

/** Prefer the "why" clause from legacy deferred reason strings. */
export function aceDeferredReasonText(reason: string | undefined | null): string {
  const trimmed = (reason ?? "").trim();
  if (!trimmed) return "Could not verify this check independently.";
  const whySplit = trimmed.split(/\bWhy:\s*/i);
  if (whySplit.length > 1) {
    return whySplit.slice(1).join("Why: ").trim() || trimmed;
  }
  const dashSplit = trimmed.match(/^Could not complete this check(?: independently)?\s*[—–-]\s*(.+)$/i);
  if (dashSplit?.[1]) return dashSplit[1].trim();
  return trimmed;
}
